import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Activity, BarChart3, Edit, Plus, Trash2 } from "lucide-react";

// Custom metrics defined by the trainer.
const MetricsTab = ({
  customMetrics,
  deleteMetric,
  metricIconMap,
  openMetricEdit,
  setEditingMetric,
  setMetricOpen,
  setNewMetric,
}) => {
  return (
    <div className="metrics-view">
      <div className="view-header">
        <h1>Metryki</h1>
        <Button onClick={() => { setEditingMetric(null); setNewMetric({ name: "", unit: "", min_value: "", max_value: "", icon: "Activity" }); setMetricOpen(true); }}>
          <Plus size={18} /> Nowa metryka
        </Button>
      </div>

      {customMetrics.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <BarChart3 size={48} strokeWidth={1} />
            <h3>Brak metryk</h3>
            <p>Dodaj własne metryki do śledzenia przez klientów</p>
          </CardContent>
        </Card>
      ) : (
        <div className="metrics-grid">
          {customMetrics.map(metric => {
            const IconComp = metricIconMap[metric.icon] || Activity;
            return (
              <Card key={metric.id} className="metric-card clickable-card" onClick={() => openMetricEdit(metric)}>
                <div className="metric-card-actions">
                  <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); openMetricEdit(metric); }}>
                    <Edit size={14} />
                  </Button>
                  <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); deleteMetric(metric.id); }}>
                    <Trash2 size={14} />
                  </Button>
                </div>
                <CardContent>
                  <IconComp size={24} />
                  <div className="metric-details">
                    <h3>{metric.name}</h3>
                    <p className="metric-unit">{metric.unit}</p>
                    {(metric.min_value != null || metric.max_value != null) && (
                      <span className="metric-range">
                        {metric.min_value != null ? metric.min_value : '—'} – {metric.max_value != null ? metric.max_value : '—'}
                      </span>
                    )}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MetricsTab;
